// App.js
import React, { useState,useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Link } from 'react-router-dom';
//import Header from './Header';    // Pour importer un fichier 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FaEnvelope } from 'react-icons/fa';  // Importer l'icône "message" de Font Awesome
import './App.css';
import ChatWindows from './components/chat_client'; // importer le composent pas juste le fichier
import Membres from "./components/Membres";



function Header() {
    return (
        <header className='header'>
 
            <h1 className='titre'>Portfolio <span id="nom">Ludovic SERRURIER </span></h1><p>
                
                <img src='../images/ludo.jpg' alt="Developpeur de Ludo" class="pic"/></p>
                {/* <button id="encre">DART</button> */}

            <nav>
               {/* <Link to="/">Liste de projets réalisés </Link> */}
                {/* <Link to="/about"> À propos de moi</Link> */}
                {/*<Link to="/contact"> Contact</Link>*/}
            </nav>
        </header>
    );
}

function TimelineEvent({ date, content }) {
    return (
    
        <div className="timeline-event">
            <div className="timeline-date">{date}</div>
            <div className="timeline-content">{content}</div>
        </div>
    );
}

// Définition du composant EmailForm
const EmailForm = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      const subject = encodeURIComponent('Nouveau message');
      const body = encodeURIComponent(`Message: ${message}`);
      const mailtoLink = `mailto:sludovic38@gmail.com?subject=${subject}&body=${body}`;
      window.location.href = mailtoLink;
    };
  
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  margin: '20px' }} >
          <form onSubmit={handleSubmit} style={{ maxWidth: '400px', width: '100%', padding: '20px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
            <h2 style={{ textAlign: 'center' }}>Envoyer un Email</h2>
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="email" style={{ display: 'block', marginBottom: '8px' }}>Votre Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="message" style={{ display: 'block', marginBottom: '8px' }}>Message:</label>
              <textarea
                id="message"
                value={message}
                placeholder='Ecrivez votre message. Cliquez sur Envoyer pour ajouter une pièce jointe.'
                onChange={(e) => setMessage(e.target.value)}
                required
                rows="4"
                style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
              />
            </div>
            <button type="submit" style={{ padding: '10px 20px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
              <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
              Envoyer
            </button>
          </form>
        </div>
      );
      
    };
  

function Accueil() {
    return (
        <div>
            <h1>Présentation</h1>
            <div className="texte">Bonjour à vous, je vous présente ci-dessous une liste non exhaustive de projets que j'ai réalisé. </div>
            <div className="texte">Ils sont présentées par ordre chronologique, de la plus récente à la plus ancienne. </div>  
            <div className="texte">Elles vous permettent de voir une partie de mes connaissances et expériences professionnelles dans ce domaine. Je m'adapte aux différentes technologies. </div> 
            <div className="texte">Je réponds a toutes vos demandes pour vous apporter une solution rapide et efficace. </div> 
            <div className="texte">Je peux travailler au TJM ou au forfait en fonction de votre demande. </div> 
            <div className="texte">Contactez-moi a cette adresse mail : 
                <a href="mailto:sludovic38@gmail.com" class="email-link">
                    <i class="fas fa-envelope" id="email" ></i>
                    <span > sludovic38@gmail.com</span>
                </a> pour votre demande. Réponses en moins de 24h du lundi ou vendredi voir le samedi si je suis disponible. </div> <br></br> 
 
            <EmailForm />

            <br /><br />

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '24px' }}></div>
            <button id="custom">REACT JS </button>
            <button id="custom">REACT JS </button>
            <button id="custom">NODE JS</button>
            <button id="custom">JAVASCRIPT</button>
            <button id="custom">SOCKET IO</button>
            <button id="custom">EXPRESS</button>
            <button id="custom">PHP</button>
            <button id="custom">PHP MY ADMIN</button>
            <button id="custom">MARIA DB</button>
            <button id="custom">SQL</button>
            <button id="custom">POSTGRESQL</button>
            <button id="custom">JSON</button>
            <button id="custom">CURL</button>
            <button id="custom">STRIPE</button>
            <button id="custom">API</button>
            <button id="custom">AJAX</button>
            <button id="custom">JQUERY</button>
            <button id="custom">FILEZILLA</button>
            <button id="custom">SHELL</button>
            <button id="custom">PLESK</button>
            <button id="custom">LETS ENCRYPT</button>
            <button id="custom">FTP</button>
            <button id="custom">WORDPRESS</button>
            <button id="custom">ORGANISATION</button>
            <button id="custom">QUALITE</button>
            <button id="custom">PHOTOSHOP</button>
            <button id="custom">VEILLE INFORMATIQUE</button>
            <button id="custom">CSV</button>
            <button id="custom">MAMP</button>
            <button id="custom">WAMP</button>
            <button id="custom">LOOKER STUDIO </button>
            <button id="custom">SSL</button>
            <button id="custom">IOS</button>
            <button id="custom">ANDROID </button>
            <button id="custom">SAUVEGARDE AUTOMATIQUE </button>
            <button id="custom">HTML</button>
            <button id="custom">CSS</button> <br></br>
            <button id="custom">FFMPEG</button>

<p></p><br></br>

           <div className="timeline-container">
                <h3>Réalisations </h3>




 <TimelineEvent 
            date=" 2024 - 2025 " 
            content={
                <div>
            <div className="image-gallery">
            <br/>
            <p>Installer Postrgesql sur un vps et lui créer une base de données mondiale qui contiens plus 13 millions de lignes (villes,codepotsal, latitude, etc..) la modifier et lui associer un drapeau en fonction du pays. </p>
             <img src='../images/1-geonames-city.png' alt="Developpeur de Ludo" /> 
             <img src='../images/3-Installer-geoname.png' alt="Developpeur de Ludo" /> 
             <img src='../images/2-geonames-flag.png' alt="Developpeur de Ludo" /> 



           {/* ... ajoutez d'autres images si nécessaire */}
                    </div>
                </div>
            } 
        />


        <TimelineEvent 
            date=" 2024 - 2025 " 
            content={
                <div>
            <div className="image-gallery">
            <br/>
            <p>Installer l’outil d’analyse statistique Matomo sur un serveur pour suivre les données liées aux visiteurs, ainsi que GeoIP pour localiser leur provenance. </p>
             <img src='../images/1-installer-matomo.png' alt="Developpeur de Ludo" />         
            <img src='../images/2-installer-matomo-geopip.png' alt="Developpeur de Ludo" />                    
           
           {/* ... ajoutez d'autres images si nécessaire */}
                    </div>
                </div>
            } 
        />

            <TimelineEvent   date=" 2023 - 2024 " 
            content={
                <div>
                 Création du portfolio https://ls-portfolio.com en react-js 
                </div>
                } 
            />


                <TimelineEvent 
                date=" 2023 - 2024 " 
                content={
                    <div>
                        Création d'une application mobile de rencontre Rencards en dart/flutter pour le front-end et node-js/PHP pour le back-end.<p></p>
                        <div className="image-gallery">
                      
                            <img src='../images/appli4.png' alt="Developpeur de Ludo" />
                            <img src='../images/appli1.png' alt="Developpeur de Ludo" />
                            <img src='../images/appli2.png' alt="Developpeur de Ludo" />

                            <img src='../images/appli5.png' alt="Developpeur de Ludo" />
                            <img src='../images/appli6.png' alt="Developpeur de Ludo" />
                            <img src='../images/appli7.png' alt="Developpeur de Ludo" />
                            <img src='../images/appli8.png' alt="Developpeur de Ludo" />
                            <img src='../images/appli9.png' alt="Developpeur de Ludo" />
 
                            {/* ... ajoutez d'autres images si nécessaire */}
                        </div>
                     </div>
                } 
            />

    
             <TimelineEvent date="01 Fev 2022" content={
                <div>
                    Création d'un site de rencontre avec abonnement payant par stripe, recherche géolocalisé par ville et distance, chat en ligne, système de favoris, système de signalement, système de visio-conférence intégré. Réalisation complète front-end & back-end. <p></p>
                    <br/><a href="https://easydate.io" target='blank'>https://easydate.io</a><p/>

                    <iframe 
                        src="https://easydate.io"
                        width="100%" 
                        height="1000" 
                        title="Description de l'iframe"
                        frameborder="0" 
                        allowfullscreen>
                   </iframe>
                </div>
                } 
            />


            {/* <p>Site de visio-conférence intégré également à easydate.io</p> */}

              <TimelineEvent 
              date="01 Janv 2021" content={
                <div>
                    Plateforme de visio-conférence en ligne avec partage d'écran, chat en ligne, tableau blanc, gestion des utilisateurs. Réalisation complète front-end & back-end. <p></p>
                    <p><a href="https://visiocam.easydate.io" target='blank' >htpps://visiocam.easydate.io</a></p>
                    <img src='../images/visiocam.jpg' alt="Developpeur de Ludo"  style={{ display: 'block', margin: 'auto',width: '60%',height:'1000' }} />
                </div>
                } 
            />

              <TimelineEvent date="15 mars 2020" content={
                <div>
                    Site pour créer des certificats d'horodatage de documents avec des clés de hachage. Réalisation complète front-end & back-end. <p></p>
                    <br/><a href="https://copyright-world.com" target='blank'>https://copyright-world.com</a><p/>
                    <iframe 
                    
                        src="https://copyright-world.com"
                        width="100%" 
                        height="1000" 
                        title="Description de l'iframe"
                        frameborder="0" 
                        allowfullscreen>
                   </iframe>
                  
                </div>
                } />
                <TimelineEvent date="1 sept 2021" content="Importation de donnée CSV dans phpmyadmin " />

                <TimelineEvent date="1 avril 2021" content="Réalisation de site wordpress" />

                <TimelineEvent date="1 Mars 2020" content="Application web pour compresser les fichiers vidéos et images" />

                {/* ... vous pouvez ajouter d'autres événements ici */}<p></p><br></br>

      
    
    <div class='footer'>
      <FontAwesomeIcon icon={faMapMarkerAlt} /><span> 74 200 Thonon les bains, France </span><br></br>
      <FontAwesomeIcon icon={faEnvelope} /><span>  sludovic38@gmail.com </span><br></br>
    <div className="status-indicator">
      <span className="status-text">Disponible</span>
    </div>
    <a href="https://www.compteurdevisite.com" title="compteur de visite html"><img src="https://counter6.optistats.ovh/private/compteurdevisite.php?c=dhr1lta6st9zns5npael1gb6dxfny3jy" border="0" title="compteur de visite html" alt="compteur de visite html"/></a>  
    
    <Membres /> {/* Utilisation du composant */}


    <div className="icon-container">
        <a href="#email">
        <FaEnvelope className="messaging-icon" size={30} color="#fff" />
        </a>
      </div>
    
    </div> {/* class footer*/}

    {/* <ChatWindows /> Affiche ton composant ici */}

 
        
            </div>
       
        </div> // inclure ci-dessus 
    );
} // accueil 
 
   
// function About() {
//     return <h1>Page à propos</h1>;
// }

// function Contact() {
//     return (
//         <div>
//             {/* <h1>Page contact</h1> */}
//             <p>
//              Vous pouvez me contacter depuis cette adresse e-mail pour toute demande : sludovic38@gmail.com
//              </p>
//              N'hésitez pas !
             
//         </div>
//     );
// }


 
 



// Matomo tracking code for React

function useMatomo() {
    useEffect(() => {
        var _paq = window._paq = window._paq || [];
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
            var u = "//copyright-world.com/matomo/";
            _paq.push(['setTrackerUrl', u + 'matomo.php']);
            _paq.push(['setSiteId', '2']);
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
        })();
    }, []);
}

// Add this hook to your App component
function App() {
    useMatomo();
    return (
        <Router>
            <div>
                <Header />
                <Routes>
                    <Route path="/" element={<Accueil />} />
                    {/* <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} /> */}
                    <Route path="/Membres" element={<Membres />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
 